import './public-path';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';


import $ from 'jquery';
window.$ = $; //定义jquery的全局变量

import "@/assets/css/common.scss";

Vue.config.productionTip = false;

Vue.use(ElementUI);
//Vue.prototype.$message = Message;

import MyDialog from '@/components/common/Dialog.vue';
Vue.component("MyDialog", MyDialog);

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  }
}).$mount("#app");
 